import Vue from 'vue'
import VueRouter from 'vue-router'
import Juhe from '../views/Juhe.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Juhe',
    component: Juhe
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
